<template>
  <div class="modal fade api-browser" :data-backdrop="backdrop">
    <div class="modal-dialog modal-dialog modal-dialog-centered" :class="size">
      <div class="modal-content">
        <!--Modal Title-->
        <slot name="header"></slot>

        <div class="modal-body p-0">
          <!--
           Filters
          -->
          <div class="filters">
            <div class="input-group">
              <slot name="filters" :params="params"></slot>
            </div>
          </div>

          <!--
            Item List
          -->
          <div class="scroller" :class="{'loading': progress}">
            <slot :items="items" name="items"></slot>
          </div>

          <!--
            Pagination
          -->
          <ul class="pagination">
            <li class="page-item" :class="{disabled: !meta.prev || progress}">
              <button :disabled="!meta.prev || progress" class="page-link prev" @click="loadData(meta.prev)">
                <i class="fas fa-arrow-left mr-1"></i> {{ 'Önceki'|trans }}</button>
            </li>
            <li class="page-item" :class="{disabled: !meta.next || progress}">
              <button :disabled="!meta.next || progress" class="page-link next" @click="loadData(meta.next)">
                {{ 'Sonraki'|trans }} <i class="fas fa-arrow-right ml-1"></i></button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiBrowser',
  props: {
    api: String,
    apiOrderBy: {type: String, default: 'created_at,desc'},
    size: {type: String, default: 'modal-lg'},
    backdrop: {type: String, default: 'false'},
  },
  data() {
    return {
      items: {},
      meta: {},
      params: {
        filters: {},
        orderBy: this.apiOrderBy
      },
      debounce: null,
      progress: false
    }
  },
  watch: {
    params: {
      deep: true,
      handler() {
        this.progress = true;
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => this.loadData(), 500)
      }
    }
  },
  methods: {
    /**
     * Open Modal
     */
    open() {
      this.loadData();
      $(this.$el).modal('show', { backdrop: false })
    },

    /**
     * Close Modal
     */
    close() {
      $(this.$el).modal('hide');
    },

    /**
     * Change Progress Status
     */
    setProgress(status) {
      this.progress = status;
    },

    /**
     * Load Data from API
     *
     * @param page int
     */
    loadData(page) {
      this.progress = true;
      const apiURL = new URL(this.api);

      // Add Filters
      Object.keys(this.params).forEach((paramKey) => {
        if (this.params[paramKey] instanceof Object){
          Object.keys(this.params[paramKey]).forEach((filterKey) => {
            apiURL.searchParams.append(`${paramKey}[${filterKey}]`, this.params[paramKey][filterKey]);
          })
        } else {
          apiURL.searchParams.append(paramKey, this.params[paramKey]);
        }
      });

      // Add Pagination
      apiURL.searchParams.append('page', (page || 1));

      // Load Data
      $.getJSON(apiURL.toString(), (response) => {
        this.items = response.data;
        this.progress = false;

        // Set Paginator
        this.meta.prev = response.meta.current_page > 1 ? response.meta.current_page - 1 : null;
        this.meta.next = response.meta.current_page === response.meta.last_page ? null : response.meta.current_page + 1;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.api-browser {
  .modal-header {
    background: var(--sidebar-selected);
    color: #FFF;
  }

  .loading{
    position: relative;
  }

  .loading:after {
    content: " ";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0,0,0,.15);
  }
}

.modal-body {
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .scroller {
    overflow: scroll;
    height: 100%;
    position: relative;
    transition: .2s all;
  }
}

.filters {
  .input-group div {
    flex: 1;
  }
}

.td-thumb {
  width: 48px;
}
.file-thumbnail {
  margin-top: -.25em;
  margin-bottom: -.25em;
  width: 36px;
  height: 36px;
}

.pagination {
  .page-item {
    width: 50%;

    button {
      width: 100%;
      margin: 0;

      &.prev {
        border-top-left-radius: 0
      }

      &.next {
        border-left-width: 0;
        border-top-right-radius: 0
      }
    }
  }
}
</style>
